export default __webpack_public_path__ + "static/media/layer08.91c26a95.png";